import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=e41e11d6&scoped=true&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=e41e11d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41e11d6",
  null
  
)

export default component.exports